export const createUuid = () => {
  // s随机串
  let d = new Date().getTime();
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }
  let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(
    c
  ) {
    let r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
};

// 判断是否是钉钉
export const isDd = () => {
  const sourceCode = localStorage.getItem('sourceCode');
  return sourceCode === '104';
};

export const openUriWithHiddenFrame = url => {
  var iframe = document.querySelector('#hiddenMiliIframe');
  if (!iframe) {
    iframe = document.createElement('iframe');
    iframe.id = 'hiddenMiliIframe';
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
  }
  console.log('开始唤起米粒客户端');
  iframe.contentWindow.location.href = url;
};
